import React from 'react';
import styles from './Busy.module.scss';
import { fadein } from '../Shared/Motion';
import { motion } from 'framer-motion';
import classNames from 'classnames';

type Props = {
  darkBackground?: boolean;
};

const Busy: React.SFC<Props> = ({ darkBackground }) => {
  return (
    <motion.div
      initial='hidden'
      animate='visible'
      variants={fadein}
      className={classNames(styles.spinnerContainer, { [styles.invertedColor]: darkBackground })}
    >
      <div className={styles.spinnerBox}>
        <div className={styles.localSpinner}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <span className={styles.loading}>Loading...</span>
      </div>
    </motion.div>
  );
};

export default Busy;
